import type { BrowserMetadata } from 'types/feedback';
import * as UAParser from 'ua-parser-js';

export function collectBrowserMetadata(): BrowserMetadata {
    try {
        const parser = new UAParser.UAParser();
        const result = parser.getResult();

        return {
            userAgent: navigator.userAgent,
            pageUrl: window.location.href,
            clientTimestamp: new Date().toISOString(),
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            viewportWidth: window.innerWidth,
            viewportHeight: window.innerHeight,
            browserName: result.browser.name,
            browserVersion: result.browser.version,
            osName: result.os.name,
            osVersion: result.os.version,
        };
    } catch (error) {
        console.error('Failed to collect browser metadata:', error);
        // Return minimal metadata - feedback submission succeeds even if metadata collection fails
        return {
            userAgent: navigator?.userAgent || 'unknown',
            pageUrl: window?.location?.href || 'unknown',
            clientTimestamp: new Date().toISOString(),
        };
    }
}
